import { useBrandService } from './brand/useBrandService'
import { useCartService } from './cart/useCartService'
import { useOrderService } from './order/useOrderService'
import { useLegalAgreementService } from './legal-agreement/useLegalAgreementService'
import { usePartnerService } from './partner/usePartnerService'
import { usePaymentService } from './payment/usePaymentService'
import { useEmailService } from './email/useEmailService'
import { useSettingsService } from './settings/useSettingsService'
import { useTestAssistService } from './test-assist/useTestAssistService'
import { useUserService } from './user'
import { useStoreService } from './stores/useStoreService'
import { useNotificationsService } from './notification/useNotificationsService'
import { useMenusService } from './menus/useMenusService'
import { useMenusCategoriesService } from './menus/categories/useMenusCategoriesService'
import { useMenusItemsService } from './menus/items/useMenusItemsService'
import { useMenusCustomizationGroupsService } from './menus/customization-groups/useMenusCustomizationGroupsService'
import { useDashboardCatalogService } from './dashboard-catalog/useDashboardCatalogService'
import { useReportsService } from './reports/useReportsService'
import { usePhoneVerificationService } from './phone-verification'
import { useReviewsService } from './reviews/useReviewsService'
import { useSearchService } from './search/useSearchService'
import { useDashboardService } from './dashboard/useDashboardService'

export function useApiClient() {
  return {
    brand: useBrandService,
    cart: useCartService,
    order: useOrderService,
    legalAgreement: useLegalAgreementService,
    partner: usePartnerService,
    payment: usePaymentService,
    email: useEmailService,
    settings: useSettingsService,
    testAssist: useTestAssistService,
    user: useUserService,
    stores: useStoreService,
    notifications: useNotificationsService,
    menus: useMenusService,
    menusCategories: useMenusCategoriesService,
    menusItems: useMenusItemsService,
    menusCustomizationGroups: useMenusCustomizationGroupsService,
    dashboardCatalog: useDashboardCatalogService,
    reports: useReportsService,
    phoneVerification: usePhoneVerificationService,
    reviews: useReviewsService,
    search: useSearchService,
    dashboard: useDashboardService
  }
}

export * from './errorHandler'
export * from './reportApiFailure'
export * from './formatUserFacingFetchError'
export * from './extractFetchValidationErrors'
export * from './mergeValidationErrorsFromSettled'

/**
 * ================
 * === Types
 * ================
 */
export type { Brand } from './interfaces/Brand'
export type { CartIndexSuccess, CartItemView } from './generated'
export * from './email/VerifyEmailParams'
export * from './user/types'
export * from './user/interfaces'
export * from './stores/types'
export * from './stores/interfaces'
export * from './menus/interfaces'
export * from './menus/categories/interfaces'
export * from './menus/items/interfaces'
export * from './menus/customization-groups/types'
export * from './menus/customization-groups/interfaces'
export * from './dashboard-catalog/types'
export * from './dashboard-catalog/interfaces'
export * from './notification/types'
export * from './notification/interfaces'
export * from './reports/types'
export * from './phone/CountryPrefix'
export * from './phone-verification/PhoneVerifyErrorData'
export * from './search/types'
export * from './search/interfaces'
